/**
 * OLD CART DRAWER CUSTOM JS - MIGRATED FROM REZ-OLD
 * Contains: ShippingProgressBar Web Component (Two Tiers), Countdown Timer, Toggle Functionality
 * Dependencies: jQuery (loaded via CDN in section file)
 */

// ============================================
// SHIPPING PROGRESS BAR WEB COMPONENT - TWO TIERS
// ============================================
// Only define if not already defined
if (!customElements.get('shipping-progress-bar')) {
  class ShippingProgressBar extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    // Default properties - Tier 1 (Free Shipping)
    this._threshold = 7500; // $75.00 in cents
    this._current = 0;
    this._currency = '$';
    this._thresholdMessage = 'Add __AMOUNT__ more to get FREE shipping!';
    this._successMessage = 'Congratulations! You qualify for FREE shipping!';
    this._progressColor = '#4CAF50';
    this._backgroundColor = '#f0f0f0';
    
    // Default properties - Tier 2 (Free Gift)
    this._enableTier2 = false;
    this._tier2Threshold = 15000; // $150.00 in cents
    this._tier2Message = 'Add __AMOUNT__ more to get a FREE gift!';
    this._tier2SuccessMessage = 'Congratulations! You get a FREE gift!';
    this._tier2ProgressColor = '#d4af37';
  }

  static get observedAttributes() {
    return [
      'threshold', 
      'current', 
      'currency', 
      'threshold-message', 
      'success-message',
      'progress-color',
      'background-color',
      'enable-tier2',
      'tier2-threshold',
      'tier2-message',
      'tier2-success-message',
      'tier2-progress-color'
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    
    switch(name) {
      case 'threshold':
        this._threshold = parseInt(newValue, 10);
        break;
      case 'current':
        this._current = parseInt(newValue, 10);
        break;
      case 'currency':
        this._currency = newValue;
        break;
      case 'threshold-message':
        this._thresholdMessage = newValue;
        break;
      case 'success-message':
        this._successMessage = newValue;
        break;
      case 'progress-color':
        this._progressColor = newValue;
        break;
      case 'background-color':
        this._backgroundColor = newValue;
        break;
      case 'enable-tier2':
        this._enableTier2 = newValue === 'true';
        break;
      case 'tier2-threshold':
        this._tier2Threshold = parseInt(newValue, 10);
        break;
      case 'tier2-message':
        this._tier2Message = newValue;
        break;
      case 'tier2-success-message':
        this._tier2SuccessMessage = newValue;
        break;
      case 'tier2-progress-color':
        this._tier2ProgressColor = newValue;
        break;
    }
    
    this.render();
  }

  connectedCallback() {
    // Get attributes on initial render - Tier 1
    if (this.hasAttribute('threshold')) {
      this._threshold = parseInt(this.getAttribute('threshold'), 10);
    }
    
    if (this.hasAttribute('current')) {
      this._current = parseInt(this.getAttribute('current'), 10);
    }
    
    if (this.hasAttribute('currency')) {
      this._currency = this.getAttribute('currency');
    }
    
    if (this.hasAttribute('threshold-message')) {
      this._thresholdMessage = this.getAttribute('threshold-message');
    }
    
    if (this.hasAttribute('success-message')) {
      this._successMessage = this.getAttribute('success-message');
    }
    
    if (this.hasAttribute('progress-color')) {
      this._progressColor = this.getAttribute('progress-color');
    }
    
    if (this.hasAttribute('background-color')) {
      this._backgroundColor = this.getAttribute('background-color');
    }
    
    // Get attributes on initial render - Tier 2
    if (this.hasAttribute('enable-tier2')) {
      this._enableTier2 = this.getAttribute('enable-tier2') === 'true';
    }
    
    if (this.hasAttribute('tier2-threshold')) {
      this._tier2Threshold = parseInt(this.getAttribute('tier2-threshold'), 10);
    }
    
    if (this.hasAttribute('tier2-message')) {
      this._tier2Message = this.getAttribute('tier2-message');
    }
    
    if (this.hasAttribute('tier2-success-message')) {
      this._tier2SuccessMessage = this.getAttribute('tier2-success-message');
    }
    
    if (this.hasAttribute('tier2-progress-color')) {
      this._tier2ProgressColor = this.getAttribute('tier2-progress-color');
    }
    
    console.log('[ShippingProgressBar] connectedCallback - attributes:', {
      threshold: this._threshold,
      current: this._current,
      currency: this._currency,
      enableTier2: this._enableTier2,
      'enable-tier2 raw attr': this.getAttribute('enable-tier2'),
      tier2Threshold: this._tier2Threshold,
      tier2Message: this._tier2Message,
      tier2SuccessMessage: this._tier2SuccessMessage,
      tier2ProgressColor: this._tier2ProgressColor,
    });
    
    this.render();
  }

  formatCurrency(cents) {
    return (cents / 100).toFixed(2) + this._currency;
  }

  render() {
    console.log('[ShippingProgressBar] render() - state:', {
      current: this._current,
      threshold: this._threshold,
      enableTier2: this._enableTier2,
      tier2Threshold: this._tier2Threshold,
    });
    
    // Determine max threshold for bar calculation
    const maxThreshold = this._enableTier2 ? this._tier2Threshold : this._threshold;
    
    // Calculate overall progress percentage (based on max threshold)
    const progressPercentage = Math.min(100, (this._current / maxThreshold) * 100);
    
    // Calculate tier 1 milestone position
    const tier1Position = this._enableTier2 
      ? Math.min(100, (this._threshold / maxThreshold) * 100) 
      : 100;
    
    // Calculate remaining amounts
    const tier1Remaining = Math.max(0, this._threshold - this._current);
    const tier2Remaining = Math.max(0, this._tier2Threshold - this._current);
    
    // Check goals reached
    const tier1Reached = this._current >= this._threshold;
    const tier2Reached = this._enableTier2 && this._current >= this._tier2Threshold;
    
    // Format remaining amounts
    const tier1FormattedAmount = this.formatCurrency(tier1Remaining);
    const tier2FormattedAmount = this.formatCurrency(tier2Remaining);
    
    // Determine active tier for text display
    let activeTier = 'tier1';
    if (tier1Reached && this._enableTier2) {
      activeTier = 'tier2';
    }
    
    // Determine current progress bar color
    const currentProgressColor = (tier1Reached && this._enableTier2) 
      ? this._tier2ProgressColor 
      : this._progressColor;
    
    // Determine message to display
    let displayMessage = '';
    if (activeTier === 'tier1') {
      displayMessage = tier1Reached 
        ? this._successMessage 
        : this._thresholdMessage.replace('__AMOUNT__', `<strong>${tier1FormattedAmount}</strong>`);
    } else {
      displayMessage = tier2Reached 
        ? this._tier2SuccessMessage 
        : this._tier2Message.replace('__AMOUNT__', `<strong>${tier2FormattedAmount}</strong>`);
    }

    // Create HTML content
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100%;
        }
        
        .progress-container {
          margin: 0;
          padding: 0;
        }

        .progress-message {
          margin-bottom: 10px;
          text-align: center;
          font-family: "Encode Sans", sans-serif;
          font-size: 12px;
          font-weight: 500;
          line-height: 1.3;
          color: #000;
        }

        .progress-message strong {
          font-weight: 700;
        }

        .progress-track {
          position: relative;
          height: 5px;
          background-color: ${this._backgroundColor};
          border-radius: 100px;
          overflow: visible;
          ${this._enableTier2 ? 'padding: 0 14px;' : ''}
        }
        
        .progress-track-inner {
          position: relative;
          width: 100%;
          height: 100%;
          background-color: ${this._backgroundColor};
          border-radius: 100px;
        }
        
        .progress-fill {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: ${progressPercentage}%;
          background-color: ${currentProgressColor};
          border-radius: 100px;
          transition: width 0.4s ease-in-out, background-color 0.3s ease-in-out;
        }
        
        .milestone {
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          z-index: 2;
          transition: background-color 0.3s ease-in-out, transform 0.3s ease-in-out;
        }
        
        .milestone svg {
          width: 14px;
          height: 14px;
        }
        
        .milestone--tier1 {
          left: ${tier1Position}%;
          background-color: ${tier1Reached ? this._progressColor : this._backgroundColor};
          color: ${tier1Reached ? '#fff' : this._progressColor};
        }
        
        .milestone--tier1.reached {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        }
        
        .milestone--tier1 svg path {
          stroke: currentColor;
          fill: none;
        }
        
        .milestone--tier2 {
          left: 100%;
          background-color: ${tier2Reached ? this._tier2ProgressColor : this._backgroundColor};
          color: ${tier2Reached ? '#fff' : this._tier2ProgressColor};
        }
        
        .milestone--tier2.reached {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          transform: translate(-50%, -50%) scale(1.1);
        }
        
        .milestone--tier2 svg {
          width: 18px;
          height: 18px;
        }
        
        .milestone--tier2 svg path {
          fill: currentColor;
          stroke: none;
        }
      </style>
      
      <div class="progress-container">
        <div class="progress-message">
          ${displayMessage}
        </div>
        <div class="progress-track">
          <div class="progress-track-inner">
            <div class="progress-fill"></div>

            ${this._enableTier2 ? `
            <!-- Tier 2 Milestone: Free Gift (gift icon) -->
            <span class="milestone milestone--tier2 ${tier2Reached ? 'reached' : ''}">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
                <path d="M160-80v-440H80v-240h208q-5-9-6.5-19t-1.5-21q0-50 35-85t85-35q23 0 43 8.5t37 23.5q17-16 37-24t43-8q50 0 85 35t35 85q0 11-2 20.5t-6 19.5h208v240h-80v440H160Zm371.5-748.5Q520-817 520-800t11.5 28.5Q543-760 560-760t28.5-11.5Q600-783 600-800t-11.5-28.5Q577-840 560-840t-28.5 11.5ZM360-800q0 17 11.5 28.5T400-760q17 0 28.5-11.5T440-800q0-17-11.5-28.5T400-840q-17 0-28.5 11.5T360-800ZM160-680v80h280v-80H160Zm280 520v-360H240v360h200Zm80 0h200v-360H520v360Zm280-440v-80H520v80h280Z"/>
              </svg>
            </span>
            ` : ''}
          </div>
        </div>
      </div>
    `;
  }
}

  // Register the custom element
  customElements.define('shipping-progress-bar', ShippingProgressBar);
}

// ============================================
// CART DRAWER COUNTDOWN TIMER
// ============================================
document.addEventListener('DOMContentLoaded', function() {
  // Select the countdown wrapper element
  const countdownWrapper = document.querySelector('.custom-countdown-wrapper');
  
  // If countdown element doesn't exist, exit early
  if (!countdownWrapper) return;
  
  // Get total minutes from data-time attribute and convert to seconds
  const totalMinutes = parseInt(countdownWrapper.getAttribute('data-time') || 10, 10);
  const TOTAL_TIME = totalMinutes * 60; // Convert minutes to seconds
  
  // Select the countdown display element
  const timerDisplay = countdownWrapper.querySelector('.custom-countdown-main');
  
  // If timer display doesn't exist, exit early
  if (!timerDisplay) return;
  
  // Timer state variables
  let timeRemaining;
  let timerInterval;
  let timerActive = false;
  
  // Function to check if cart has items
  async function checkCartHasItems() {
    try {
      // Fetch cart data from Shopify
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.item_count > 0;
    } catch (error) {
      console.error('Error checking cart:', error);
      return false;
    }
  }
  
  // Initialize timer
  initializeTimer();
  
  // Functions
  async function initializeTimer() {
    // Check if cart has items first
    const hasItems = await checkCartHasItems();
    
    if (!hasItems) {
      // Hide countdown if cart is empty
      countdownWrapper.style.display = 'none';
      clearCartTimerStorage();
      return;
    }
    
    // Check if there's a stored timer value in sessionStorage
    const storedTimeStamp = sessionStorage.getItem('cartTimerExpiry');
    const storedTimeRemaining = sessionStorage.getItem('cartTimeRemaining');
    
    if (storedTimeStamp && storedTimeRemaining) {
      const now = Date.now();
      const expiry = parseInt(storedTimeStamp, 10);
      
      // Calculate how much time has passed since the timer was paused
      if (now < expiry) {
        // Timer was still running, calculate remaining time
        timeRemaining = Math.round((expiry - now) / 1000);
      } else {
        // Timer expired since last visit
        timeRemaining = 0;
      }
    } else {
      // First time initialization
      timeRemaining = TOTAL_TIME;
    }
    
    // If timer is at 0, reset it to full time
    if (timeRemaining <= 0) {
      timeRemaining = TOTAL_TIME;
    }
    
    // Make countdown visible
    countdownWrapper.style.display = '';
    
    // Update display and start timer
    updateTimerDisplay();
    startTimer();
  }
  
  function startTimer() {
    if (!timerActive) {
      timerActive = true;
      
      // Store the expected end time
      const expiryTime = Date.now() + (timeRemaining * 1000);
      sessionStorage.setItem('cartTimerExpiry', expiryTime);
      
      timerInterval = setInterval(function() {
        timeRemaining--;
        updateTimerDisplay();
        
        // Update sessionStorage every second
        sessionStorage.setItem('cartTimeRemaining', timeRemaining);
        sessionStorage.setItem('cartTimerExpiry', Date.now() + (timeRemaining * 1000));
        
        if (timeRemaining <= 0) {
          // Timer completed
          handleTimerComplete();
        }
      }, 1000);
    }
  }
  
  function stopTimer() {
    // Clear interval
    clearInterval(timerInterval);
    timerActive = false;
    
    // Hide the countdown wrapper
    countdownWrapper.style.display = 'none';
    
    // Clear the sessionStorage
    clearCartTimerStorage();
  }
  
  function updateTimerDisplay() {
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    
    // Format time as MM:SS
    timerDisplay.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  
  function handleTimerComplete() {
    // Clear interval
    clearInterval(timerInterval);
    timerActive = false;
    
    // Hide the countdown wrapper
    countdownWrapper.style.display = 'none';
    
    // Clear the sessionStorage for cart timer
    clearCartTimerStorage();
  }
  
  function clearCartTimerStorage() {
    // Remove all cart timer related items from sessionStorage
    sessionStorage.removeItem('cartTimeRemaining');
    sessionStorage.removeItem('cartTimerExpiry');
  }
  
  // Shopify specific - listen for cart updates
  document.addEventListener('cart_drawer:updated', async function(event) {
    if (event.detail && event.detail.cart) {
      if (event.detail.cart.item_count === 0) {
        // Cart is empty, stop timer
        stopTimer();
      } else if (!timerActive) {
        // Cart has items and timer is not active, start timer
        timeRemaining = TOTAL_TIME; // Reset to full time
        countdownWrapper.style.display = '';
        updateTimerDisplay();
        startTimer();
      }
    } else {
      // If event.detail.cart is not available, check cart manually
      const hasItems = await checkCartHasItems();
      if (!hasItems) {
        stopTimer();
      } else if (!timerActive) {
        timeRemaining = TOTAL_TIME;
        countdownWrapper.style.display = '';
        updateTimerDisplay();
        startTimer();
      }
    }
  });
  
  // Alternative approach for Shopify - monitor Ajax requests
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const promise = originalFetch.apply(this, arguments);
    
    // Check if this is a cart update
    if (url && typeof url === 'string') {
      if (url.includes('/cart/clear.js') || url.includes('/cart/clear')) {
        // Cart clear request
        promise.then(() => {
          stopTimer();
        });
      } else if (url.includes('/cart/add.js') || url.includes('/cart/add') || 
                url.includes('/cart/update.js') || url.includes('/cart/update') ||
                url.includes('/cart/change.js') || url.includes('/cart/change')) {
        // Cart addition/update request
        promise.then(async (response) => {
          const hasItems = await checkCartHasItems();
          if (hasItems && !timerActive) {
            timeRemaining = TOTAL_TIME;
            countdownWrapper.style.display = '';
            updateTimerDisplay();
            startTimer();
          }
        });
      }
    }
    
    return promise;
  };
  
  // No visibility change handling - countdown continues running in background
  
  // Function to handle window unload (close/refresh)
  window.addEventListener('beforeunload', function() {
    if (timerActive) {
      sessionStorage.setItem('cartTimeRemaining', timeRemaining);
      sessionStorage.setItem('cartTimerExpiry', Date.now() + (timeRemaining * 1000));
    }
  });
});

// ============================================
// BUNDLE PRODUCT TOGGLE FUNCTIONALITY
// ============================================
$(document).ready(function() {
  // Add click handler for all toggle headers
  $(document).on("click",".toggle-header", function() {
      // Toggle visibility of the associated grocery items
      $(this).next(".grocery-items").toggle();
     $(this).find(".dropdown-icon").toggleClass("open");

    let headerTextElement = $(this).find(".header-text");
    let currentText = headerTextElement.text();
    
    if (currentText.includes("Afficher")) {
        headerTextElement.text(currentText.replace("Afficher", "Masquer"));
    } else {
        headerTextElement.text(currentText.replace("Masquer", "Afficher"));
    }
  });
});
